import { useCallback } from 'react';
import { IHandleSetValueParams, TInputState } from '../types';
import { THandleSetValue } from './types';
import { isBoolean, isString } from 'lodash';

export const useHandleSetValue = ({
  inputs,
  setInputs,
}: IHandleSetValueParams): THandleSetValue => {
  return useCallback(
    (name: string, srcValue?: TInputState['value']) => {
      const input = inputs[name];
      const value = isString(srcValue) && srcValue === '' ? undefined : srcValue;
      if (!input) return;
      const newInput = {
        ...input,
        value,
        touched: isBoolean(value) ? !!input.initialValue !== value : input.initialValue !== value,
        errors: undefined,
      };
      const newInputs = { ...inputs, [name]: newInput };
      setInputs(newInputs);
    },
    [inputs, setInputs]
  );
};
